import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'settings/environment';
//import Logo from '../../../ui-component/Logo';
import React from 'react';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={'/'}>
        <img
            alt='Logo'
            src={`${config.rutaImagenes}/logos/logo.svg`}
            height='55'
            width='180'
        />
    </ButtonBase>
);

export default LogoSection;
